import React, {useContext, useState} from 'react';
import {defineMessages, useIntl} from 'react-intl';
import {Button} from '@igp/shared/components/button';
import {FormControlGroup} from '@igp/shared/components/form';
import {LocalizedText} from '@igp/shared/components/i18n';
import {ModalContext, ModalFooter} from '@igp/shared/components/modal';
import {AgentAutocomplete} from '@igp/shared/features/agent-profile';
import {EntityType} from '@models';

import {useDebtResponsibleMasterAgentActions} from '../hooks';

const localized = defineMessages({
    addAgent: {
        id: 'DebtResponsibleMasterAgent_AddAgentModal_addAgent',
        defaultMessage: 'Add Agent',
    },
    usernameLabel: {
        id: 'DebtResponsibleMasterAgent_AddAgentModal_autocompletePlaceholder',
        defaultMessage: 'Master Agent Username',
    },
    cancel: {
        id: 'DebtResponsibleMasterAgent_AddAgentModal_cancel',
        defaultMessage: 'Cancel',
    },
    confirm: {
        id: 'DebtResponsibleMasterAgent_AddAgentModal_confirm',
        defaultMessage: 'Confirm',
    },
});

function AddAgentModal() {
    const {formatMessage} = useIntl();
    const {closeModal} = useContext(ModalContext);
    const {addDebtResponsibleMasterAgent} = useDebtResponsibleMasterAgentActions();
    const [selectedAgentId, setSelectedAgentId] = useState('');

    function handleAddAgent() {
        if (selectedAgentId) {
            addDebtResponsibleMasterAgent({agent_id: selectedAgentId});
            closeModal();
        }
    }

    function handleAutocompleteChange(value: string) {
        setSelectedAgentId(value);
    }

    return (
        <form onSubmit={handleAddAgent}>
            <FormControlGroup label={formatMessage(localized.usernameLabel)} labelVariant="default" labelPlacement="left">
                <AgentAutocomplete
                    viewType="AddDebtResponsibleMasterAgent"
                    value={selectedAgentId}
                    onChange={handleAutocompleteChange}
                    agentProfileEntity={EntityType.AgentProfile}
                    mode="default"
                    onlyMasterAgents
                />
            </FormControlGroup>
            <ModalFooter>
                <Button type="button" color="secondary" variant="contained" label={localized.cancel} onClick={closeModal} />
                <Button type="submit" color="primary" variant="contained" label={localized.confirm} disabled={!selectedAgentId} />
            </ModalFooter>
        </form>
    );
}

export function AddDebtResponsibleMasterAgentButton() {
    const {openModal} = useContext(ModalContext);

    function handleAddAgent() {
        openModal({
            title: <LocalizedText label={localized.addAgent} />,
            body: <AddAgentModal />,
        });
    }

    return <Button color="primary" variant="contained" label={localized.addAgent} onClick={handleAddAgent} />;
}
